module.exports = __webpack_public_path__ + "assets/img/checked2-76b5f7f7.png";